import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminContent from "./components/AdminContent";
function Admin(){
    return (
        <div>
        <Header/>
        <AdminContent/>
        <Footer/>
        </div>
    )
}
export default Admin;